<sbnb-loading-spinner minHeight="200px" *ngIf="(submitting$ | async) === true"></sbnb-loading-spinner>
<ng-container *ngIf="unsubmitted$ | async">
  <form class="flex flex-col" style="gap: 36px" [formGroup]="deleteUsersForm">
    <h3>
      You must delete {{ maxSecondaryUsersEntitlement.disable }} secondary
      {{ 'users' | pluralize: maxSecondaryUsersEntitlement.disable }}
    </h3>
    <div class="scrollable-card">
      <div class="flex flex-wrap w-full justify-between items-center">
        <div class="text__large">Secondary Users</div>
        <div class="flex justify-end" style="gap: 12px">
          <sbnb-button type="text-secondary" size="mini" (click)="users.selectAll()">Select all</sbnb-button>
          <sbnb-button type="text-secondary" size="mini" (click)="users.deselectAll()">Clear selection</sbnb-button>
        </div>
      </div>
      <mat-selection-list #users formControlName="users">
        <mat-list-option
          [checkboxPosition]="'before'"
          *ngFor="let user of maxSecondaryUsersEntitlement.data"
          [value]="user.id">
          <div class="flex items-center">
            <span>{{ user.name }}</span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </div>

    <div class="flex flex-col" style="gap: 12px">
      <strong>What does this mean:</strong>
      <div style="margin-left: 24px">Deleted users will immediately lose access to your Hospitable account</div>
    </div>
    <mat-divider></mat-divider>

    <div>
      <mat-checkbox style="padding: 0; align-items: start" formControlName="confirm" class="flex items-start">
        <strong>I confirm I understand the above and wish to delete</strong>
      </mat-checkbox>
    </div>
    <div class="flex justify-between">
      <button mat-flat-button class="button__secondary" [disabled]="submitting$ | async" (click)="cancel.emit()">
        Cancel
      </button>
      <div class="flex w-full justify-end" style="gap: 12px">
        <button mat-flat-button class="button__secondary" [disabled]="submitting$ | async" (click)="previous.emit()">
          Back
        </button>
        <button
          mat-flat-button
          class="button__primary"
          [disabled]="(submitting$ | async) || deleteUsersForm.invalid"
          (click)="deleteUsers()">
          Delete
        </button>
      </div>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="success$ | async">
  <div class="flex flex-col items-center justify-center" style="gap: 24px; height: 200px; margin-bottom: 24px">
    <h3>Successfully deleted users</h3>
    <sbnb-icon icon="check" class="grass-darker" [size]="36"></sbnb-icon>
  </div>
</ng-container>
<ng-container *ngIf="error$ | async">
  <div class="flex flex-col items-center justify-center" style="gap: 24px; height: 200px; margin-bottom: 24px">
    <h3>An error occurred while trying to delete</h3>
    <img height="36" width="36" src="/assets/iconography/rejected.svg" />
  </div>
</ng-container>
